import { trialFeatures } from 'client/util/Constants/FeatureTrialConstants';
import MspState from 'client/components/models/MspState';
import store from 'client/store';

const InvoicesPage = () => import('client/Account/InvoicesPage.vue');
const OverviewPage = () => import('client/Account/OverviewPage/OverviewPage.vue');
const PaymentInfoPage = () => import('client/Account/PaymentInfoPage.vue');
const TabbedAccountPage = () => import('client/Account/TabbedAccountPage.vue');
const UpgradePage = () => import('client/Account/UpgradePage');

export default (enabledFlags) => {
  const meta = {
    loadLegacyStyles: false,
    title: 'Account',
  };

  return [{
    path: '/account/',
    name: 'Account',
    meta,
    redirect: { name: 'Overview' },
    components: {
      mainPanel: TabbedAccountPage,
    },
    children: [
      {
        path: 'general',
        name: 'Overview',
        component: OverviewPage,
        meta,
      },

      {
        path: 'payment',
        name: 'Payment Info',
        component: PaymentInfoPage,
        meta,
      },
      {
        path: 'invoices',
        name: 'Invoices',
        component: InvoicesPage,
        meta,
      },
      {
        path: 'upgrade',
        name: 'Upgrade',
        component: UpgradePage,
        meta: {
          ...meta,
          uiEvents_page: 'Upgrade Page',
        },
        beforeEnter: (to, from, next) => {
          const planHasFeature = store.getters['PlanModule/planHasFeature'];
          const isFullyUpgraded = planHasFeature(trialFeatures.osPatchManagement.featureCode)
            && planHasFeature(trialFeatures.zeroTrust.featureCode);
          const showRoute = enabledFlags.upgradePage
            && !MspState.isAnMsp
            && store.getters['SettingsModule/getIsCustomer']
            && !isFullyUpgraded;

          if (showRoute) {
            next();
          } else {
            next({ path: '/home' });
          }
        },
      },
    ],
  }];
};
